import axios from '../utils/axios'

// 获取搜索列表数据
export function GetHistoricalSearch () {
  return axios({
    url: '/SaleV2/Product/GetHistoricalSearch',
    method: 'post'
  })
}

// 未登录情况下，获取历史搜索记录接口
export function NoAuthGetHistoricalSearch () {
  return axios({
    url: '/NoAuth/Product/GetHistoricalSearch',
    method: 'post'
  })
}

export function NoAuthGetHotSearch () {
  return axios({
    url: '/NoAuth/Product/GetHotSearch',
    method: 'post'
  })
}

// 期望商品反馈
export function SaveHopeProduct (data) {
  return axios({
    url: '/Sale/Sale/SaveHopeProduct',
    method: 'post',
    data: data
  })
}

// 清空历史搜索
export function DeleteHistoricalSearch (data) {
  return axios({
    url: '/SaleV2/Product/DeleteHistoricalSearch',
    method: 'post',
    data: data
  })
}

// 未登录情况下，清除历史搜索记录接口
export function NoAuthDeleteHistoricalSearch (data) {
  return axios({
    url: '/NoAuth/Product/DeleteHistoricalSearch',
    method: 'post',
    data: data
  })
}
